import { Outlet } from 'react-router';
import LangsComponent from '../langs/langs';
import { Menubar } from 'primereact/menubar';
import React from 'react';
import { Button } from 'primereact/button';
import AuthService from '../../api/authService';
import useMenu from '../../routes/routes';

const NavigationComponent = () => {
  const { menu } = useMenu();

  const onLogout = async () => {
    await AuthService.logout();
    window.location.href = '/';
  };

  const endControls = (
    <div className="flex flex-wrap justify-content-center gap-1">
      <LangsComponent />
      <Button icon="pi pi-sign-out" rounded text onClick={onLogout} />
    </div>
  );

  return (
    <>
      <Menubar model={menu} end={endControls} />
      <div className="mt-1 min-h-screen">
        <Outlet />
      </div>
    </>
  );
};

export default NavigationComponent;
